import Icon from '../components/Icon.vue'

Icon.register({
  'drafting-compass': {
    width: 512,
    height: 512,
    paths: [
      {
        d: 'M457 344.4C432 364.8 404.4 381.6 374.5 393.5L428.9 487.7 482.8 510.7C492.6 514.9 503.7 508.5 505 497.9L512 439.6 457 344.4zM499.5 249.9C504.4 242.2 501.4 231.9 493.4 227.5L465.4 211.9C457.9 207.8 448.8 210.4 444.1 217.6 403 281.1 332.3 320 256 320 232.1 320 208.8 315.8 186.6 308.5L253.9 191.8C254.7 191.8 255.3 192 256 192S257.3 191.8 258 191.8L309.1 280.3C340.4 271.3 368.7 254.5 391.7 231.4L339.9 141.7C347.4 128 352 112.6 352 96 352 43 309 0 256 0S160 43 160 96C160 112.6 164.6 128 172.1 141.7L103.8 260C91.2 248.4 79.8 235.4 70.1 221 65.3 213.9 56.1 211.3 48.7 215.6L20.9 231.7C13.1 236.3 10.3 246.6 15.3 254.2 30.9 277.8 50 298.4 71.3 316.2L0 439.7 7 497.9C8.3 508.5 19.4 514.9 29.2 510.7L83.1 487.7 153.9 365C186.1 377.3 220.6 384 256 384 355.1 384 446.9 333 499.5 249.9zM256 64C273.7 64 288 78.3 288 96S273.7 128 256 128 224 113.7 224 96 238.3 64 256 64z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/drafting-compass.js
// module id = Nqmy
// module chunks = 144